import * as user from './user.js';
import * as course from './course.js';
import * as ability from './ability.js';
import * as leadership from './leadership.js';
import * as project from './project.js';

import Vue from 'vue'
const api = {
    ...user,
    ...course,
    ...ability,
    ...leadership,
    ...project
}
export default api


// WEBPACK FOOTER //
// ./src/api/index.js